import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { HelperFormModule } from '@core/components/helpers/form/form.module';

import { RulesHelpersSearchMainComponent } from './search-main/main.component';
import { RulesHelpersSearchResultsComponent } from './results/results.component';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HelperFormModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        RulesHelpersSearchMainComponent,
        RulesHelpersSearchResultsComponent
    ],
    exports: [
        RulesHelpersSearchMainComponent
    ],

})
export class SettingsRulesRulesFormHelpersSearchModule { }